const STORAGE_KEY = "onboarding:subSteps"

export const subStepsStorage = {
  get: () => localStorage.getItem(STORAGE_KEY),
  set: (value) => localStorage.setItem(STORAGE_KEY, value),
  remove: () => localStorage.removeItem(STORAGE_KEY)
}
